import {
  getSharedFolderDetails,
  listSnapshots,
  createBackup,
  listSharedFolders,
  exportSnapshot,
  restoreSnapshot
} from "@/services/api/dropbox/recovery/shared-folder/sharedFolder";
import {defaultPagination} from "@/services/pagination";
import files from "@/store/app/dropbox/recovery/shared-folder/data-set/file";
import exports from "@/store/app/dropbox/recovery/shared-folder/exports";
import restores from "@/store/app/dropbox/recovery/shared-folder/restores";
import backups from "@/store/app/dropbox/recovery/shared-folder/backups";
import user from "@/store/app/dropbox/recovery/shared-folder/user";
import {
  connectAws,
  connectAzure, connectBox,
  connectDropbox, connectGoogle,
  connectGoogleCloud, connectMicrosoft,
  connectS3Compatible, deleteConnection, listConnection, listRegion, listRegionsGCP
} from "@/services/api/common/connection";

const defaultState = () => ({
  sharedFolders: [],
  sharedFolderMap: {},
  listRegions: {},
  listRegionsGcp: {},
  pagination: {
    ...defaultPagination(),
    sortBy: 'name',
    sortDescending: false
  },
  search: null
});

export default {
  namespaced: true,
  actions: {
    listSharedFolders({commit, state},) {
      return listSharedFolders({
        pagination: state.pagination,
        search: state.search,
        filter: {
          "statuses": [
            1, 2, 4
          ]
        }
      })
        .then(({result, pagination}) => {
          commit('setSharedFolders', result)
          commit('setPagination', pagination)
        })
    },
    getSharedFolderDetails({commit}, sharedFolderId) {
      return getSharedFolderDetails(sharedFolderId)
        .then(sharedFolder => {
          commit('setSharedFolder', sharedFolder);
          return sharedFolder;
        })
    },
    createBackup({commit}, sharedFolderId) {
      return createBackup(sharedFolderId);
    },
    listSnapshots({commit}, {sharedFolderId, date, dateTo}) {
      return listSnapshots({sharedFolderId, date, dateTo});
    },
    exportSnapshot({commit}, data) {
      return exportSnapshot({
        ...data,
        dataType: '11'
      });
    },
    restoreSnapshot({}, data) {
      return restoreSnapshot(data);
    },
    connectAws({commit}, data) {
      return connectAws(data);
    },
    connectAzure({commit}, data) {
      return connectAzure(data);
    },
    connectS3Compatible({commit}, data) {
      return connectS3Compatible(data);
    },
    connectGoogleCloud({commit}, data) {
      return connectGoogleCloud(data);
    },
    connectDropbox({commit}, data) {
      return connectDropbox(data);
    },
    connectGoogle({commit}, data) {
      return connectGoogle(data);
    },
    connectMicrosoft({commit}, data) {
      return connectMicrosoft(data);
    },
    connectBox({commit}, data) {
      return connectBox(data);
    },
    listConnection({commit}, data) {
      return listConnection(data);
    },
    deleteConnection({commit, state}, {id}) {
      return deleteConnection(id)
    },
    listRegion({commit, state}) {

      return listRegion()
        .then(region => {
          commit('setRegion', region);
          return region;
        })
    },
    listRegionGCP({commit, state}) {
      return listRegionsGCP()
        .then(region => {
          commit('setRegionGcp', region); // Commits to new mutation
          return region;
        })
    },
  },

  mutations: {
    setSharedFolders(state, sharedFolders) {
      state.sharedFolders = sharedFolders;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    resetPagination(state, {keepSort}) {
      if (keepSort) {
        state.pagination = {
          ...defaultPagination(),
          sortBy: state.pagination.sortBy,
          sortDescending: state.pagination.sortDescending,
        }
      } else {
        state.pagination = {
          ...defaultPagination(),
          sortBy: 'name',
          sortDescending: false
        };
      }

    },
    setSearchFiles(state, search) {
      state.search = search;
    },
    setSharedFolder(state, sharedFolder) {
      state.sharedFolderMap = {
        ...state.sharedFolderMap,
        [sharedFolder.sharedFolderId]: sharedFolder
      };
    },
    resetState(state) {
      Object.assign(state, defaultState())
    },
    setRegion(state, regions) {
      state.listRegions = regions
    },
    setRegionGcp(state, regions) {
      state.listRegionsGcp = regions
    },
  },

  getters: {
    getSharedFolderById: (state) => (id) => {
      return state.sharedFolderMap[id];
    },

    getDriveUserById: (state, getters, rootState, rootGetters) => (userId) => {
      return rootGetters["dropbox/recovery/dropboxDrive/getUserById"](userId);
    },
    getListRegions: (state) => () => {
      if (Array.isArray(state.listRegions)) {
        return state.listRegions.map(region => ({
          ...region,
          label: region.displayName,
          value: region.systemName
        }));
      } else {
        return [];
      }
    },
    getListRegionsGcp: (state) => () => {
      if (Array.isArray(state.listRegionsGcp)) {
        return state.listRegionsGcp.map(region => ({
          ...region,
          label: region.displayName,
          value: region.systemName
        }));
      } else {
        return [];
      }
    },
  },

  state: defaultState,

  modules: {
    files,
    exports,
    restores,
    backups,
    user
  },
}
